/**
 * @generated SignedSource<<54a55626b2abe239ba97a0c6e174a11a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingPage_viewer$data = {
  readonly invoicesV2: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly projects: ReadonlyArray<{
          readonly id: string;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly company: {
    readonly currency: string | null;
    readonly clients: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly xeroContactId: string | null;
          readonly economicCustomerId: string | null;
          readonly quickbooksCustomerId: string | null;
          readonly sageIntacctCustomerId: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTableSection_company">;
  } | null;
  readonly project: {
    readonly id: string;
    readonly client: {
      readonly id: string;
    } | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTotals_project" | "ProjectInvoicingUninvoicedItemsTableSection_project" | "ProjectInvoicingTableSection_project">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTableSection_viewer">;
  readonly " $fragmentType": "ProjectInvoicingPage_viewer";
};
export type ProjectInvoicingPage_viewer$key = {
  readonly " $data"?: ProjectInvoicingPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 31,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": 12,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": 2099,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "invoiceProjectIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": 2020,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingPage_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectInvoicingTableSection_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100000
        },
        {
          "kind": "Variable",
          "name": "invoiceProjectIds",
          "variableName": "invoiceProjectIds"
        }
      ],
      "concreteType": "InvoiceTypeConnection",
      "kind": "LinkedField",
      "name": "invoicesV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InvoiceType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectType",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": true,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientTypeConnection",
          "kind": "LinkedField",
          "name": "clients",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Client",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "xeroContactId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "economicCustomerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "quickbooksCustomerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sageIntacctCustomerId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectInvoicingTableSection_company"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectInvoicingTotals_project"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "endDay",
              "variableName": "endDay"
            },
            {
              "kind": "Variable",
              "name": "endMonth",
              "variableName": "endMonth"
            },
            {
              "kind": "Variable",
              "name": "endYear",
              "variableName": "endYear"
            },
            {
              "kind": "Variable",
              "name": "startDay",
              "variableName": "startDay"
            },
            {
              "kind": "Variable",
              "name": "startMonth",
              "variableName": "startMonth"
            },
            {
              "kind": "Variable",
              "name": "startYear",
              "variableName": "startYear"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ProjectInvoicingUninvoicedItemsTableSection_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectInvoicingTableSection_project"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "91cd686bcb1c722c2b2dc5df1091ee65";

export default node;
